<div class="not-found" style="padding-top: 30px;">
   <h1>401</h1>
   <span class="message">
   Oops, you are not authorized to view this page. <a [routerLink]="['/student-search']" replace>click here</a> to return
   to the homepage.
   </span>  
</div>